











































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';

import TitleBar from '@/components/Elements/TitleBar.vue'

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
// @ts-ignore
import ruLocale from '@fullcalendar/core/locales/ru';
import { createPopper } from '@popperjs/core';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',
      'filter',
    ]),
    ...mapGetters(STORE_KEY, [
      'eventSources',
    ]),
  },
  components: {
    TitleBar,
    FullCalendar,
  }
})
export default class Calendar extends Vue {

  get titleStack () {
    return [
      'Календарь'
    ]
  }

  calendarPlugins = [ dayGridPlugin ]
  locale = ruLocale

  eventRender(params: any) {
    // {event, el, view}
    params.el.dataset.tooltip = params.event.title;
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange();
    this.$store.dispatch(`${STORE_KEY}/loadData`);
  }

  // ---------------------------------------------------------------------------

  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`);
  }

  public refreshData($event: any) {
    this.$store.dispatch(`${STORE_KEY}/loadData`)
      .finally(() => {
        $event.detail.complete();
      });
  }
}
